<template>
  <div>
    <Card dis-hover>
      <Row :gutter="16">
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理组:</span>
            <Select
              v-model="table.platid"
              placeholder="下拉筛选盘口所属分组服务器"
              @on-change="changeTablePlatid"
            >
              <Option
                v-for="(item, index) in select.platform_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }} <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">代理组:</span>
            <Select
              v-model="table.params.app_id"
              placeholder="输入盘口名称、APPID或下拉筛选"
              filterable
              @on-change="GetAllAppMch"
            >
              <Option
                v-for="(item, index) in getShowAppList()"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">支付类型:</span>
            <Select
              v-model="table.params.self_type"
              placeholder="输入或选择支付类型"
              filterable
              allow-create
              clearable
            >
              <Option
                v-for="item in select.pay_type_List"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 110px">支付子商户:</span>
            <Select
              v-model="table.params.pay_id"
              placeholder="输入或选择支付子商户
"
              filterable
              allow-create
              clearable
            >
              <Option
                v-for="item in select.pay_id_List"
                :key="item.pay_id"
                :value="item.pay_id"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">支付状态:</span>
            <Select
              v-model="table.params.status"
              placeholder="输入或选择支付状态"
              clearable
            >
              <Option
                v-for="item in select.status_List"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">子商户:</span>
            <Input
              v-model="table.params.packNo"
              placeholder="搜索 子商户号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="4" style="margin-top: 10px">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">玩家ID:</span>
            <Input
              v-model="table.params.user_id"
              placeholder="搜索 玩家ID"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="4" style="margin-top: 10px">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">操作人ID:</span>
            <Input
              v-model="table.params.opt"
              placeholder="搜索 后台操作人ID"
              clearable
            ></Input>
          </label>
        </Col>
      </Row>
      <Row :gutter="16" style="margin-top: 12px; white-space: nowrap">
        <Col span="3">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">订单号:</span>
            <Input
              v-model="table.params.order_no"
              placeholder="搜索 订单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">筛选时间:</span>
            <DatePicker
              type="datetimerange"
              placeholder="选择时间"
              v-model="select.dataTime"
              style="width: 100%"
            ></DatePicker>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">三方订单号:</span>
            <Input
              v-model="table.params.other_no"
              placeholder="搜索 第三方订单号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 100px">操作人身份:</span>
            <Select
              v-model="table.params.source_type"
              placeholder="操作人身份"
              clearable
            >
              <Option
                v-for="item in select.source_type_List"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="5">
          <span style="margin-right: 5px">订单操作金额区间</span>
          <InputNumber
            v-model="table.params.min_point"
            style="width: 28%"
            :min="0"
            placeholder="金额最小值"
          ></InputNumber>
          --
          <InputNumber
            v-model="table.params.max_point"
            style="width: 28%"
            :min="0"
            placeholder="金额最大值"
          ></InputNumber>
        </Col>
        <Col span="4" style="margin-top: 10px">
          <label style="display: flex; align-items: center">
            <span style="width: 60px">端口号:</span>
            <Input
              v-model="table.params.channel_id"
              placeholder="搜索 转入端口号"
              clearable
            ></Input>
          </label>
        </Col>
        <Col span="1" style="margin-top: 10px">
          <Button type="primary" @click="GetRetrieveData(1)">查询</Button>
        </Col>
        <Col span="2" style="text-align: center;margin-top: 10px;">
          <Button type="primary" @click="GetRetrieveData(0, false)"
            >列表汇总统计</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <!-- 列表汇总弹框 -->
    <Modal width="1100px" v-model="hzTable.show">
      <p slot="header" class="modal-header" style="text-align: center">
        列表汇总统计
      </p>
      <Table border :columns="hzTable.columns" :data="hzTable.data"></Table>
    </Modal>
    <!-- 响应状态 -->
    <Modal v-model="responModal.show">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>响应状态</span>
      </p>
      <span style="word-wrap: break-word; word-break: normal">{{
        responModal.response
      }}</span>
    </Modal>
  </div>
</template>
<script>
import { GetAllPlatform, GetAllAppList, TransTopReq } from "@/api/admin/risk";
export default {
  name: "Paymentorder",
  data() {
    return {
      select: {
        pay_type_List: [
          { text: "公司入账", value: 1 },
          { text: "线上转入", value: 2 },
          { text: "银行卡转入", value: 3 },
          { text: "系统赠送", value: 4 },
          { text: "小额转入", value: 5 },
          { text: "专享闪付", value: 6 },
        ], //支付类型
        pay_id_List: [], //支付id
        status_List: [
          { text: "全部", value: 0 },
          { text: "等待支付", value: 1 },
          { text: "支付成功", value: 2 },
          { text: "取消支付", value: 3 },
        ], //支付状态
        source_type_List: [
          { text: "全部", value: -1 },
          { text: "运营转入", value: 0 },
          { text: "银商转入", value: 1 },
        ], //操作人身份
        platform_list: [], //平台列表
        appid_list: [], //盘口列表
        all_app_list: [], //所有盘口列表
        dataTime: [
          this.getCurrentZeroDay(),
          new Date(new Date().setHours(23, 59, 59, 59)),
        ],
      },
      // 响应状态
      responModal: { show: false, response: "" },
      hzTable: {
        show: false,
        data: [],
        columns: [
          {
            key: "order_num",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "提交订单数",
                "当前筛选之后剩余的订单数量"
              );
            },
          },
          {
            key: "order_point",
            align: "center",
            minWidth: 90,
            render: (h, params) => {
              return h("span", (params.row.order_point / 10000).toFixed(2));
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "提交订单操作金额",
                "当前筛选之后剩余的订单的操作金额之和"
              );
            },
          },
          {
            key: "success_num",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "成功支付订单数",
                "当前筛选之后的已成功支付的订单数量"
              );
            },
          },
          {
            key: "success_point",
            align: "center",
            minWidth: 90,
            render: (h, params) => {
              return h("span", (params.row.success_point / 10000).toFixed(2));
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "成功转入实际金额",
                "当前筛选之后的已成功支付的订单金额之和"
              );
            },
          },
          {
            key: "order_man",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "提交订单人数",
                "当前筛选之后的订单提交人数，该数据去重"
              );
            },
          },
          {
            key: "fee_point",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              return h("span", (params.row.fee_point / 10000).toFixed(2));
            },
            renderHeader: (h, params) => {
              return this.renderHeader(h, "手续费", "当前筛选之后的手续费");
            },
          },
          {
            key: "success_man",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "完成订单人数",
                "当前筛选之后的完成支付订单的人数，该数据去重"
              );
            },
          },
          {
            key: "old_point",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              return h(
                "span",
                params.row.success_num == 0
                  ? 0
                  : (
                      (params.row.success_num / params.row.order_num) *
                      100
                    ).toFixed(2) + "%"
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "订单转入成功率",
                "成功支付订单数/提交订单数"
              );
            },
          },
          {
            key: "old_point",
            align: "center",
            minWidth: 90,
            render: (h, params) => {
              return h(
                "span",
                params.row.success_point == 0
                  ? 0
                  : (
                      (params.row.success_point /
                        10000 /
                        (params.row.order_point / 10000)) *
                      100
                    ).toFixed(2) + "%"
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "成功转入金额占比",
                "成功转入订单金额/提交订单金额"
              );
            },
          },
          {
            key: "old_point",
            align: "center",
            minWidth: 110,
            render: (h, params) => {
              return h(
                "span",
                params.row.success_man == 0
                  ? 0
                  : (
                      (params.row.success_man / params.row.order_man) *
                      100
                    ).toFixed(2) + "%"
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "实际完成订单人数比",
                "完成订单人数/提交订单人数"
              );
            },
          },
        ],
      },
      table: {
        platid: 0,
        // app_id: 0,
        total: 0,
        pageSizes: [10, 20, 30, 40, 50],
        params: {
          app_id: 0,
          page: 1,
          limit: 10,
          sort: 0,
          packNo: "",
          pack_no: "",
          user_id: "",
          pay_id: "",
          opt: "",
          status: "",
          self_type: "",
          other_no: "",
          order_no: "",
          pay_source: "",
          channel_id: "",
          source_type: "",
          min_point: null,
          max_point: null,
          stime: 0,
          etime: 0,
          is_new: "",
        },
        data: [],
        columns: [
          {
            title: "订单号",
            key: "order_no",
            align: "center",
            width: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "订单号",
                "显示该条支付信息对应的订单号"
              );
            },
          },
          {
            key: "other_no",
            align: "center",
            minWidth: 85,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "第三方订单号",
                "显示发起该条转入订单的第三方订单号"
              );
            },
          },
          {
            key: "name",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "用户名称",
                "显示发起该条转入订单的用户名称"
              );
            },
          },
          {
            key: "user_id",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "用户ID",
                "显示发起该条转入订单的用户ID"
              );
            },
          },
          {
            key: "job_name",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              return h("div", [
                h("p", params.row.job_name),
                h("p", params.row.job_no ? `（${params.row.job_no}）` : ""),
              ]);
            },
            renderHeader: (h, params) => {
              return this.renderHeader(h, "所属工号", "显示该玩家所属工号");
            },
          },
          {
            key: "old_point",
            align: "center",
            minWidth: 100,
            render: (h, params) => {
              return h(
                "span",
                params.row.old_point == -1
                  ? "暂未转入"
                  : (params.row.old_point / 10000).toFixed(2)
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "操作前账户余额",
                "显示转入发起未到账时的账户余额"
              );
            },
          },
          {
            key: "point",
            align: "center",
            sortable: true,
            minWidth: 80,
            render: (h, params) =>
              h("span", (params.row.point / 10000).toFixed(2)),
            renderHeader: (h, params) =>
              this.renderHeader(h, "操作金额", "转入操作时输入的金额"),
          },
          {
            key: "real_point",
            align: "center",
            minWidth: 90,
            render: (h, params) =>
              h("span", (params.row.real_point / 10000).toFixed(2)),
            renderHeader: (h, params) =>
              this.renderHeader(h, "实际操作金额", "玩家实际的操作金额"),
          },
          {
            key: "new_point",
            align: "center",
            minWidth: 100,
            render: (h, params) =>
              h(
                "span",
                params.row.new_point == -1
                  ? "暂未转入"
                  : (params.row.new_point / 10000).toFixed(2)
              ),
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                "操作后账户余额",
                "显示为转入到账时的账户余额"
              ),
          },
          {
            key: "fee_point",
            align: "center",
            minWidth: 65,
            render: (h, params) => {
              return h("span", (params.row.fee_point / 10000).toFixed(2));
            },
            renderHeader: (h, params) => {
              return this.renderHeader(h, "手续费", "显示为转入所需手续费");
            },
          },
          {
            key: "pay_type",
            align: "center",
            minWidth: 65,
            render: (h, params) => {
              return h(
                "span",
                [
                  "公司入账",
                  "线上支付",
                  "银行卡支付",
                  "赠送支付",
                  "小额支付",
                  "专享闪付",
                ][params.row.pay_type - 1]
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "支付类型",
                "根据订单的支付子商户筛选数据信息"
              );
            },
          },
          {
            key: "pay_id",
            align: "center",
            minWidth: 80,
            render: (h, params) => {
              let str = "";
              if (params.row.pay_id != 0) {
                this.select.pay_id_List.map((pay) => {
                  if (params.row.pay_id == pay.pay_id) {
                    str = pay.name;
                  }
                });
              } else {
                str = "";
              }
              return h("span", str);
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, "支付子商户", "根据订单的支付子商户"),
          },
          {
            key: "pay_source",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(h, "来源", "根据订单的支付来源");
            },
          },
          {
            key: "status",
            align: "center",
            minWidth: 65,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: `${
                      params.row.status == "99"
                        ? "#ccc"
                        : ["red", "blue", "#ccc"][params.row.status - 1]
                    }`,
                  },
                },
                params.row.status == "99"
                  ? "异常"
                  : ["等待支付", "支付成功", "取消支付"][params.row.status - 1]
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "支付状态",
                "显示该条转入订单的状态：已完成"
              );
            },
          },
          {
            key: "update_time",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(h, "更新时间", "显示完成转入操作的时间");
            },
          },
          {
            key: "pack_no",
            align: "center",
            minWidth: 65,
            renderHeader: (h, params) => {
              return this.renderHeader(h, "所属子商户", "所属子商户");
            },
          },
          {
            key: "pay_desc",
            align: "center",
            minWidth: 65,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "操作备注",
                "显示转入时运营填写的信息"
              );
            },
          },
          {
            key: "source_type_name",
            align: "center",
            minWidth: 80,
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "操作人身份",
                "显示操作此订单的后台操作用户的属性身份"
              );
            },
          },
          {
            key: "source_opt",
            align: "center",
            minWidth: 65,
            render: (h, params) => {
              return h(
                "span",
                params.row.source_opt == 0 ? "" : params.row.source_opt
              );
            },
            renderHeader: (h, params) => {
              return this.renderHeader(
                h,
                "操作人ID",
                "显示完成转入操作的后台账户ID"
              );
            },
          },
          {
            key: "",
            title: "操作",
            align: "center",
            minWidth: 80,
            fixed: "right",
            render: (h, params) => {
              return h("div", [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      disabled: params.row.status == 1 ? false : true,
                    },
                    style: {
                      margin: "2px",
                      padding: "3px 8px",
                    },
                    on: {
                      click: () => {
                        this.responModal.response =
                          params.row.response == ""
                            ? "暂时无响应"
                            : params.row.response;
                        this.responModal.show = true;
                      },
                    },
                  },
                  "响应状态"
                ),
              ]);
            },
          },
        ],
      },
    };
  },
  methods: {
    //排序
    changeSort(data) {
      this.table.params.sort = data.order == "desc" ? 2 : 1;
      this.GetRetrieveData();
    },
    //列表分页
    pagechange(page) {
      this.table.params.page = page;
      this.GetRetrieveData();
    },
    //列表分条
    limitchange(limit) {
      this.table.params.page = 1;
      this.table.params.limit = limit;
      this.GetRetrieveData();
    },
    //获取平台列表
    async GetAllAppList() {
      this.select.appid_list = this.select.all_app_list.filter(
        (el) => el.platform == this.table.platid
      );
      this.table.params.app_id = this.select.appid_list[0]["appid"];
      this.GetNewAppPayChannel();
    },
    //获取所有盘口
    getInitAppList(list) {
      list = list || [];
      let param = {
        page: 1,
        page_size: 10000,
      };
      GetAllAppList(param).then((res) => {
        let data = this.copyData(res._param.List || []);
        data = data.filter((el) => el.appid);
        list = list.filter((el) => data.some((item) => item.platform == el.id));
        this.select.platform_list = list;
        this.table.platid = list[0]["id"];
        this.select.all_app_list = data;
        this.select.appid_list = data;
        this.table.params.app_id = data.filter(
          (item) => item.platform == this.table.platid
        )[0]["appid"];
        this.GetNewAppPayChannel();
        // this.GetRetrieveData()
      });
    },
    changeTablePlatid() {
      let item = this.getShowAppList()[0];
      this.table.params.app_id = item ? item.appid : 0;
    },
    //获取所有平台
    GetAllPlatform() {
      GetAllPlatform({}).then(async (res) => {
        this.getInitAppList(res._param.data);
      });
    },
    //读取盘口所有支付平台
    GetAllAppMch(val) {
      let find = this.select.appid_list.find((el) => el.appid == val);
      if (find && this.table.platid != find.platform) {
        this.table.platid = find.platform;
      }
      this.GetNewAppPayChannel();
    },
    //获取系统支持的支付子商户

    GetNewAppPayChannel() {
      let params = {
        app_id: this.table.params.app_id,
        mod: 1,
      };
      TransTopReq(this.returnParam("GetNewAppPayChannel", params)).then(
        (res) => {
          this.select.pay_id_List = res._param.list;
          this.GetRetrieveData();
        }
      );
    },
    //列表数据(汇总，表单)
    GetRetrieveData(num, type = true) {
      if (
        Number(this.table.params.min_point) >
        Number(this.table.params.max_point)
      ) {
        return this.$Message.error("请输入正确的操做金额区间");
      }
      let params = {
        ...this.table.params,
        pack_no:
          this.table.params.packNo == ""
            ? -1
            : Number(this.table.params.packNo),
        user_id: Number(this.table.params.user_id),
        pay_id: Number(this.table.params.pay_id),
        opt: Number(this.table.params.opt),
        status: Number(this.table.params.status),
        self_type: Number(this.table.params.self_type),
        source_type:
          this.table.params.source_type == null
            ? -1
            : Number(this.table.params.source_type),
        min_point: Number(this.table.params.min_point),
        max_point: Number(this.table.params.max_point),
        stime: this.getSecondResult(this.select.dataTime[0]),
        etime: this.getSecondResult(this.select.dataTime[1]),
        is_new: 1,
      };
      if (type || num == 1) {
        if (num == 1) {
          params.page = 1;
        }
        //表单数据
        TransTopReq(this.returnParam("GetAllPayList", params)).then((res) => {
          this.table.data = res._param.data;
          this.table.total = res._param.total;
        });
      } else {
        //汇总数据
        this.hzTable.show = true;
        TransTopReq(this.returnParam("GetAllPaySummary", params)).then(
          (res) => {
            let obj = { ...res._param };
            let arr = [];
            arr.push(obj);
            this.hzTable.data = arr;
          }
        );
      }
    },
    getShowAppList() {
      return this.select.appid_list.filter(
        (el) => el.platform == this.table.platid
      );
    },
    // 接口请求
    returnParam(func, param) {
      return {
        mod: "root",
        platid: this.table.platid,
        app_id: this.table.params.app_id,
        param: {
          _mod: "manager",
          _func: func,
          _param: {
            ...param,
          },
        },
      };
    },
  },

  created() {
    this.GetAllPlatform();
  },
};
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
